/**
 * Por onde um item pode ENTRAR num fluxo — a regra, sem rede nem React.
 *
 * Um fluxo pode declarar VÁRIAS etapas por onde o item entra ("pode iniciar
 * por esta etapa", marcada no desenho do fluxo): quando há marcadas, todas
 * valem. Só quando nenhuma está marcada é que se recorre à heurística de ler
 * o desenho — a etapa que não recebe seta de ninguém.
 *
 * Mora em arquivo próprio, separado do hook, porque o hook importa o cliente
 * da API, que toca `window` no import e não existe fora do navegador. Assim a
 * regra pode ser testada sozinha (SPEC-20260918-2341).
 */

type NoDoFluxo = { flowId: string; flowStepId: string; isInitial?: boolean }

export function portasDeEntrada<T extends NoDoFluxo>(
  nos: readonly T[],
  ligacoes: readonly { to: string }[],
  fluxosDoTipo: readonly string[],
): T[] {
  const destinos = new Set(ligacoes.map((l) => l.to))
  return [...new Set(fluxosDoTipo)].flatMap((flowId) => {
    const doFluxo = nos.filter((n) => n.flowId === flowId)
    const marcadas = doFluxo.filter((n) => n.isInitial)
    if (marcadas.length > 0) return marcadas
    const heuristica = doFluxo.find((n) => !destinos.has(n.flowStepId)) ?? doFluxo[0]
    return heuristica ? [heuristica] : []
  })
}
